<template>
  <div class="about">
    <div class="uk-section" 
				id="topBanner" 
        style="background-color:white" >
			<div class="uk-container">
				<div class="uk-flex uk-flex-center uk-flex-middle uk-height-medium uk-height-max-small" uk-grid>
					<div class="uk-text-center">
						<p class="uk-text-large" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Smart Home Appliance Store</p>
						<p class="uk-heading-small uk-text-bold uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">About</p>
					</div>
				</div>
			</div>
		</div>
    <h1 class="uk-heading-divider"></h1>
    <div class="uk-section">
			<div class="uk-container">
				<div class="uk-grid" uk-grid>
					<div class="uk-width-1-2@s">
						<div uk-scrollspy="cls: uk-animation-scale-up; delay: 300; repeat: true;" class="" uk-slideshow="autoplay: true" >
							<div class="uk-slideshow-items slider-contact">
								<div>
									<img :src="require('../assets/roomi_store/foto_store/TAMPAK DEPAN.jpg')" alt="" uk-cover>
									<div class="uk-position-bottom uk-animation-slide-bottom uk-margin-medium-bottom flex flex-center uk-text-center uk-margin-medium-left uk-margin-medium-right">
									</div>
								</div>
								<div>
									<img :src="require('../assets/roomi_store/foto_store/IMG_5355.jpg')" alt="" uk-cover>
									<div class="uk-position-bottom uk-animation-slide-bottom uk-margin-medium-bottom flex flex-center uk-text-center uk-margin-medium-left uk-margin-medium-right">
									</div>
								</div>
                <div>
									<img :src="require('../assets/roomi_store/foto_store/testing spk.jpg')" alt="" uk-cover>
									<div class="uk-position-bottom uk-animation-slide-bottom uk-margin-medium-bottom flex flex-center uk-text-center uk-margin-medium-left uk-margin-medium-right">
									</div>
								</div>
							</div>
              <ul class="uk-slideshow-nav uk-dotnav uk-flex-center uk-margin" uk-slideshow-nav></ul>
						</div>
					</div>
					<div class="uk-width-1-2@s">
            <p class="font-description uk-text-primary uk-text-bolder uk-text-primary" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">Exquisite Selections</p>
            <h1 class="uk-text-bold uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-right; delay: 500; repeat: true;">Transforming Your Home Experience</h1>
            <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">PT. Sumber Digital Media is a retail company in Indonesia specializing in the sale of electronic goods and home appliances. A wide range of smart home products, including Smart LEDs, Smart Security Cameras, LED TVs, and Smart TVs.</p>
            <p class="font-description uk-text-bold uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Quality Products</p>
            <progress class="uk-progress uk-margin-small-top" :value="qualityProgress" max="100"></progress>
            <!-- <p class="font-description uk-text-bold uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Expert Advice</p>
            <progress class="uk-progress uk-margin-small-top" :value="expertProgress" max="100"></progress> -->
            <p class="font-description uk-text-bold uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Customer Satisfaction</p>
            <progress class="uk-progress uk-margin-small-top" :value="customerProgress" max="100"></progress>
            <!-- <button class="uk-button uk-button-primary uk-margin-top" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">See Products</button> -->
					</div>
				</div>
			</div>
		</div>
    <h1 class="uk-heading-divider"></h1>
    <div class="uk-section">
			<div class="uk-container">
				<div class="uk-grid uk-grid-small" uk-grid>
					<div class="uk-width-1-1@s uk-text-center">
						<p class="font-description uk-text-primary uk-text-bolder uk-text-primary" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Timeless Glamour</p>
            <h1 class="uk-text-bold uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-left; delay: 500; repeat: true;">Innovative Technology, Expert Curation</h1>
            <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">At ROOMI, we believe that your home should be more than just a place to live, it should be a space to experience. That’s why we curate the best home appliances and entertainment systems to create the perfect environment for you and your family. Explore our collections today and transform your home experience.</p>
            <button @click="goTo('support')" class="uk-button uk-button-primary uk-margin-bottom" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Contact Us</button>
					</div>
					<div class="uk-width-1-2@s">
            
					</div>
				</div>
			</div>
		</div>
    <h1 class="uk-heading-divider"></h1>
    <div class="uk-section">
			<div class="uk-container">
        <div class="uk-text-center">
          <p class="font-description uk-text-primary uk-text-bolder uk-text-primary" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Exceptional Quality</p>
          <h1 class="uk-text-bold uk-margin-remove" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">Affordable Solutions for Your Home</h1>
          <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">At ROOMI, we believe that your home should be more than just a place to live, it should be a space to experience. That’s why we curate the best home appliances and entertainment systems to create the perfect environment for you and your family. Explore our collections today and transform your home experience.</p>
        </div>
        <div class="uk-grid uk-grid-large" uk-grid>
					<div class="uk-width-1-2@s">
            <div class="" uk-slideshow="autoplay: true" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">
							<div class="uk-slideshow-items slider-contact">
								<div v-for="(product, index) in solutionBanner" :key="index">
									<img :src="product.image" alt="" uk-cover>
									<div class="uk-position-bottom uk-animation-slide-bottom uk-margin-medium-bottom flex flex-center uk-text-center uk-margin-medium-left uk-margin-medium-right">
									</div>
								</div>
							</div>
						</div>
          </div>
          <div class="uk-width-1-2@s">
            <div class="uk-grid uk-grid-small" uk-grid>
              <div class="uk-width-1-2@s" uk-scrollspy="cls: uk-animation-slide-right; delay: 500; repeat: true;">
                <img :src="require('../assets/images/home/cctv.jpeg')" alt="TV Image">
              </div>
              <div class="uk-width-1-2@s" uk-scrollspy="cls: uk-animation-slide-left; delay: 500; repeat: true;">
                <img :src="require('../assets/images/home/ottbox.jpeg')" alt="TV Image">
              </div>
              <div class="uk-width-1-2@s" uk-scrollspy="cls: uk-animation-slide-right; delay: 500; repeat: true;">
                <img :src="require('../assets/images/home/speaker.jpg')" alt="TV Image">
              </div>
              <div class="uk-width-1-2@s" uk-scrollspy="cls: uk-animation-slide-left; delay: 500; repeat: true;">
                <img :src="require('../assets/images/home/tv.jpg')" alt="TV Image">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="uk-section">
			<div class="uk-container">
        <div class="uk-text-center">
          <h1 class="uk-text-bold uk-margin-remove"  uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">Discover the Future of Home Entertainment</h1>
          <p class="font-description uk-text-light" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">Experience the immersive world of home entertainment with ROOMI. Our curated collections offer the latest in audio and video technology to transform your home experience.</p>
        </div>
      </div>
    </div> -->
    <!-- <div class="uk-section uk-background-secondary">
      <div class="uk-container">
        <div class="uk-grid" uk-grid ref="grid">
          <div class="uk-width-1-3@s">
            <div class="uk-text-center">
              <h1 class="font-white uk-text-bold uk-heading-medium">
                <transition name="number-slide">
                  <span v-if="showNumber1">{{ number1 }}</span>
                </transition>
              </h1>
              <h1 class="font-white uk-text-bold" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Smart Camera</h1>
            </div>
          </div>
          <div class="uk-width-1-3@s">
            <div class="uk-text-center">
              <h1 class="font-white uk-text-bold uk-heading-medium">
                <transition name="number-slide">
                  <span v-if="showNumber2">{{ number2 }}</span>
                </transition>
              </h1>
              <h1 class="font-white uk-text-bold" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Smart TV</h1>
            </div>
          </div>
          <div class="uk-width-1-3@s">
            <div class="uk-text-center">
              <h1 class="font-white uk-text-bold uk-heading-medium">
                <transition name="number-slide">
                  <span v-if="showNumber3">{{ number3 }}</span>
                </transition>
              </h1>
              <h1 class="font-white uk-text-bold" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">Speaker</h1>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: [
    "productName",
    "description",
    "features",
    "price",
    "link",
    "img",
    "imgScale",
    "imgPositionX",
    "imgPositionY",
    "spesification",
  ],
  data() {
    return {
      product: this.productName,
      image: require("../assets/roomi_web-02.jpg"),
      imagess: require("../assets/Frame 18.jpg"),
      banner: require('../assets/woman-in-white-blazer-holding-tablet-computer-789822EDIT.jpg'),
      qualityProgress: 0,
      expertProgress: 0,
      customerProgress: 0,
      number1: 0,
      number2: 0,
      number3: 0,
      showNumber1: false,
      showNumber2: false,
      showNumber3: false,
      observer: null,
      solutionBanner: [
        {
          image: this.encodeURI('https://api.roomi.co.id/images/ROOMI AERO.jpeg')
        },
        {
          image: this.encodeURI('https://api.roomi.co.id/images/ROOMI AERO.jpeg')
        },
      ]
    };
  },
  mounted() {
    this.animateProgress();
    // this.setupIntersectionObserver();
  },
  methods : {
    animateProgress() {
      setTimeout(() => {
        this.qualityProgress = 90;
      }, 500);

      setTimeout(() => {
        this.expertProgress = 75;
      }, 1000);

      setTimeout(() => {
        this.customerProgress = 95;
      }, 1500);
    },
    setupIntersectionObserver() {
      const options = {
        root: null, // use the viewport as the root
        rootMargin: '0px', // no margin
        threshold: 0.5, // 50% of the component must be in view
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.startAnimation();
            this.observer.unobserve(entry.target);
          }
        });
      }, options);

      this.observer.observe(this.$refs.grid); // observe the grid element
    },
    startAnimation() {
      this.showNumber1 = true;
      this.animateNumber(76, 'number1');
      this.showNumber2 = true;
      this.animateNumber(56, 'number2');
      this.showNumber3 = true;
      this.animateNumber(83, 'number3');
    },
    animateNumber(targetNumber, propName) {
      const increment = 1;
      const animate = () => {
        if (this[propName] < targetNumber) {
          this[propName] = Math.min(this[propName] + increment, targetNumber); 
          requestAnimationFrame(animate);
        }
      };

      animate();
    },
    goTo(url){
      this.$router.push({ path: `/${url}` });
    },
    encodeURI(url) {
      return encodeURI(url);
    },
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect(); // disconnect observer to clean up
    }
  }
};
</script>

<style scoped>
.number-slide-enter-active,
.number-slide-leave-active {
  transition: all 0.5s ease-out; /* Adjust timing function and duration as needed */
  transition-delay: 0.2s; /* Optional delay between each number's animation */
}
.number-slide-enter, .number-slide-leave-to {
  transform: translateY(20px); /* Adjust initial animation state */
  opacity: 0; /* Optional: fade effect */
}

#product-spesification .uk-section {
  padding-bottom: 80px;
}

#top-section {
  border: 1px solid rgb(67, 67, 68);
  border-radius: 10px;
  height: 350px;
}

#product-features {
  padding: 40px 0 40px 40px;
}

#product-features div {
  margin-top: 2vw;
}

#product-features h3 {
  margin-bottom: 0;
  font-size: 20px;
  letter-spacing: 0.3vw;
  color: rgb(95, 103, 105);
  line-height: normal;
}

#product-features p {
  color: rgb(194, 195, 197);
  letter-spacing: 2px;
  font-weight: 100;
  line-height: 1;
  font-size: 1.1vw;
  margin-bottom: 2.5vw;
}

p.price {
  color: #403f41;
}

#product-features ul {
  padding-left: 0;
  list-style-position: inside;
  margin-bottom: 3vw;
}

#product-features ul li {
  font-size: 0.7vw;
  margin-bottom: 15px;
}

#product-features a.uk-button {
  border-radius: 10px;
  font-size: 11px;
  letter-spacing: 1px;
}

#trapezoid {
}

#trapezoid img {
  width: 100%;
}

@media screen and (max-width: 639px) {
  #top-section {
    height: auto;
    max-height: auto !important;
  }

  #product-features p {
    font-size: 14px;
  }

  #product-features ul li {
    font-size: 10px;
  }
}
</style>